import React, { useState, useEffect } from 'react'
import { Box, Button, IconButton, Tooltip, Typography, TextField, MenuItem, CircularProgress } from "@mui/material";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function TodayRate() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [rateDate, setRateDate] = useState(new Date());
    const [openModal, setOpenModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [rateValue, setRateValue] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [editState, setEditState] = useState(null);
    useEffect(() => {
        fetchTodayData();
    }, []);
    const formatDate = (date) => {
        if (!date) return "-";
        return date.split("T")[0].split("-").reverse().join("-");
    };
    const fetchTodayData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "todayrate";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "productcategory";
            const response = await makeRequest("get", url);
            if (response) {
                setProductCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAdd = () => {
        setSelectedCategory("");
        setRateValue("");
        setRateDate(new Date());
        setEditState(null);
        setOpenModal(true);
    };
    const openEdit = (data) => {
        setEditState(data);
        setRateValue(data?.rate_per_gram);
        setRateDate(data?.effective_date ? new Date(data.effective_date) : null);
        setSelectedCategory(data?.product_category_id);
        setOpenModal(true);
    };
    const handleSave = async () => {
        if (!selectedCategory && !rateValue.trim() && !rateDate) {
            setMessage("Product Name, Date and Rate are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const stateEditData = {
                    product_category_id: selectedCategory,
                    rate_per_gram: rateValue,
                    effective_date: rateDate
                };
                try {
                    let url = webEndPoint + "todayrate/" + editState.rfId;
                    const response = await makeRequest("put", url, stateEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Today Rate Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const stateAddData = {
                    product_category_id: selectedCategory,
                    rate_per_gram: rateValue,
                    effective_date: rateDate
                };
                try {
                    let url = webEndPoint + "todayrate";
                    const response = await makeRequest("post", url, stateAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Today Rate Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            fetchTodayData();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const columns = ["S.No", "Product Category", "Rate", "Effective Date", "Action"];
    const rows = dataSource.map((r, i) => [i + 1, r.category_name, r.rate_per_gram, r.effective_date ? formatDate(r.effective_date) : "",
    <Box>
        <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => openEdit(r)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 500 }}>Today Rate</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Add Today Rate</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {openModal && (
                <Box component="div" sx={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 400 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editState !== null ? "Edit Today Rate" : "Add Today Rate"}</Typography>
                        <TextField select label="Product Category" fullWidth value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} sx={{ mb: 2 }}>
                            {productCategory.map((cat) => (
                                <MenuItem key={cat} value={cat?.rfId}>{cat?.category_name}</MenuItem>
                            ))}
                        </TextField>
                        <TextField label="Rate per Gram" type="number" fullWidth value={rateValue} onChange={(e) => setRateValue(e.target.value)} sx={{ mb: 2 }} />
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="Effective Date"
                                value={rateDate}
                                format="dd-MM-yyyy"
                                onChange={(newValue) => setRateDate(newValue)}
                                maxDate={new Date()}
                                shouldDisableDate={(date) => {
                                    return date < new Date().setHours(0, 0, 0, 0);
                                }}
                                slotProps={{ textField: { fullWidth: true, sx: { mb: 2 } } }} />
                        </LocalizationProvider>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                            <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}